import { render } from "./MerchantSettlement.vue?vue&type=template&id=17c0081d&scoped=true"
import script from "./MerchantSettlement.vue?vue&type=script&lang=js"
export * from "./MerchantSettlement.vue?vue&type=script&lang=js"

import "./MerchantSettlement.vue?vue&type=style&index=0&id=17c0081d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c0081d"]])

export default __exports__